import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { projectsDirectoryManageRedirectRoute } from '@jira/router-routes__directories-routes/src/projectsDirectoryManageRedirectRoute.tsx';
import { ProjectsDirectorySkeleton } from '@jira/platform__skeletons/src/ui/directories/FiltersDirectorySkeleton.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { ProjectsDirectoryManageRedirect } from './ui/ProjectsDirectoryManageRedirect.tsx';
import { adminProjectDirectoryResources } from './common/adminProjectDirectoryResources.tsx';
import { LazyProjectsDirectory } from './common/LazyProjectsDirectory.tsx';

export const projectsDirectoryManageRedirectRouteEntry: Route = createEntry(
	projectsDirectoryManageRedirectRoute,

	() => ({
		// eslint-disable-next-line no-restricted-syntax
		component: ProjectsDirectoryManageRedirect,
		skeleton: ProjectsDirectorySkeleton,
		isRedirect: true,
		layout: globalSettingsLayout,

		navigation: {},

		resources: [...getNavigationResources(), ...adminProjectDirectoryResources()],
		forPaint: [LazyAtlassianNavigation, LazyProjectsDirectory],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
